module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/CC-BY-120.25022dba.png";